'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactRouter = require('react-router');


var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);


var _CompanyRealtors = require('./CompanyRealtors.scss');var styles = _interopRequireWildcard(_CompanyRealtors);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Helpers
// Modules
var CompanyRealtors = function CompanyRealtors(props) {
  var renderRealtor = function renderRealtor(item, idx) {var _cx;var
    name = item.name,image = item.image,id = item.id,is_staff = item.is_staff;
    var handleClick = function handleClick() {return is_staff && _reactRouter.browserHistory.push((0, _appendLocale2.default)(props.locale, '/staff/' + id));};

    return (
      _react2.default.createElement('div', {
          key: image + '_' + idx,
          className: (0, _classnames2.default)(styles.realtor, (_cx = {}, _cx[
          styles.staff] = is_staff, _cx)),

          onClick: handleClick },

        _react2.default.createElement('div', { className: styles.realtorImage },
          _react2.default.createElement('img', { src: image, alt: '' })),

        _react2.default.createElement('span', null, name)));


  };

  var renderRealtors = function renderRealtors() {return props.realtors && props.realtors.map(renderRealtor);};
  var renderFirstRealtors = function renderFirstRealtors() {return props.realtors && renderRealtor(props.realtors[0]);};

  return (
    _react2.default.createElement('div', { className: styles.realtorsBlock },
      props.isAdvanced ?
      renderRealtors() :
      renderFirstRealtors()));



}; // Styles

CompanyRealtors.propTypes = {
  realtors: _propTypes2.default.array,
  locale: _propTypes2.default.string,
  isAdvanced: _propTypes2.default.bool };exports.default =


CompanyRealtors;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyRealtors/CompanyRealtors.js
// module id = 1196
// module chunks = 0